import actions from "@/store/modules/receipt/actions";
import mutations from "@/store/modules/receipt/mutations";
import state from "@/store/modules/receipt/state";

export default {
    actions,
    mutations,
    state
}